import { render, staticRenderFns } from "./parameterScreening.vue?vue&type=template&id=c5a69ba8&scoped=true&"
import script from "./parameterScreening.vue?vue&type=script&lang=js&"
export * from "./parameterScreening.vue?vue&type=script&lang=js&"
import style0 from "./parameterScreening.vue?vue&type=style&index=0&id=c5a69ba8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a69ba8",
  null
  
)

export default component.exports